let magicLinkToken: string | null = null;

// Run before telemetry and routing initialize so the credential never becomes a page URL in either.
export const captureMagicLinkToken = () => {
  if (typeof window === 'undefined' || window.location.pathname !== '/login/email') {
    return;
  }

  const fragment = new URLSearchParams(window.location.hash.slice(1));
  magicLinkToken = fragment.get('token')?.trim() || null;
  if (window.location.hash) {
    window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
  }
};

export const getMagicLinkToken = () => magicLinkToken;

export const clearMagicLinkToken = () => {
  magicLinkToken = null;
};
